<script lang="ts" setup>
import _ from 'lodash'
import { computed, type ComputedRef, type Ref, ref } from 'vue'

import { filterStructuredDocument } from '../../components/health-data/utils'
import dayjs from '../../misc/dayjs'
import type { DocumentSourceIdentifier, HealthConstant } from '../../types/health-data'
import OcticonButton from '../OcticonButton.vue'

export interface HealthConstantsViewerProps {
  healthConstants: HealthConstant[]
  activeIds: number[]
}

const props = defineProps<HealthConstantsViewerProps>()

const emit = defineEmits<{
  (e: 'show-source', documentSource: DocumentSourceIdentifier): void
}>()

const filtering = ref(null) as Ref<string>
const filteringOptions = {
  threshold: 0.49,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['constantType.description', 'value', 'unit'],
}
const displayedHealthConstants = computed(() =>
  filterStructuredDocument(props.healthConstants, filtering.value, filteringOptions),
)
const sortedHealthConstants: ComputedRef<HealthConstant[]> = computed(() => _.orderBy(displayedHealthConstants.value, 'constantDate', 'desc'))
</script>

<template>
  <div>
    <div class="card-body row">
      <h1 class="report-title col">
        Constantes
      </h1>
      <div class="col-auto form-group">
        <input
          v-model="filtering"
          type="text"
          placeholder="Filtrage rapide"
          class="form-control col-auto"
        >
      </div>
    </div>
    <div class="card-body table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Nom</th>
            <th>Valeur</th>
            <th>Unité</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="healthConstant in sortedHealthConstants"
            :key="`constant-${healthConstant.id}`"
            :class="{ 'hinted-line-highlighted': activeIds.includes(healthConstant.id) }"
          >
            <td>{{ healthConstant.creationDate ? dayjs(healthConstant.creationDate).format('L') : '-' }}</td>
            <td>{{ healthConstant.constantType.description }}</td>
            <td>{{ healthConstant.value }}</td>
            <td>{{ healthConstant.unit }}</td>
            <td>
              <Octicon-button
                v-if="healthConstant.documentSourceIdentifier"
                octicon-name="hubot"
                custom-class="icon-link"
                title="Voir le document d'origine"
                :width="20"
                :height="20"
                @click="emit('show-source', healthConstant.documentSourceIdentifier)"
              />
            </td>
          </tr>
          <tr v-if="!sortedHealthConstants.length">
            Aucune constante ne correspond au filtre "{{ filtering }}"
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
